module.exports = __webpack_public_path__ + "img/cashless_payments.f7ab88ea.webp";